
var _ = require('underscore');
var Backbone = require('backbone');
var ajax = require('ajax');

var Translator = require('translate').singleton;
var __ = Translator.get;

var TemplateCache = require('TemplateCache');


var SiteSearchResultView = Backbone.View.extend({

	events: {
		'click .search-next': 'handleNext',
		'click .search-prev': 'handlePrev',
	},

	initialize: function() {
		this.listenTo(this.model, "change:results change:startIndex change:isLoading", this.render);
	},

	render: function() {
		if ( this.model.get("isLoading") ) {
			this.el.innerHTML = TemplateCache.render(this.model.get("template_id"), {
				isLoading: true,
			});
			return;
		}

		var startIndex = this.model.get("startIndex");
		var resultsCount = this.model.get("resultsCount");
		var perPage = this.model.get("perPage");
		var results = this.model.get('results').slice(startIndex, startIndex + this.model.get('perPage'));

		var nextPageIndex = startIndex + perPage;
		var paginationInfo = [
			__("collectible.results"),
		  	(startIndex + 1),
		  	"-",
		    (nextPageIndex < resultsCount ? nextPageIndex : resultsCount)
		];
		if ( nextPageIndex <= resultsCount ) {
			paginationInfo.push(__("collectible.of"));
			paginationInfo.push(resultsCount);
		}

		this.el.innerHTML = TemplateCache.render(this.model.get("template_id"), {
			isLoading: false,
			results: results,
			startIndex: startIndex,
			resultsCount: resultsCount,
			perPage: perPage,
			hasPrev: startIndex > 0,
			hasNext: (startIndex + perPage) < resultsCount,
			paginationInfo: paginationInfo.join(" "),
		});
	},

	handleNext: function(e) {
		e.preventDefault();
		this.model.set("startIndex", this.model.get("startIndex") + this.model.get('perPage'));
	},

	handlePrev: function(e) {
		e.preventDefault();
		this.model.set("startIndex", this.model.get("startIndex") - this.model.get('perPage'));
	},

});


var TraminoSiteSearch = Backbone.Model.extend({

	defaults: function() {
		return {
			/* Parameters */
			api: null,
			template_id: null,
			render_to: null,
			perPage: 10,

			/* State */
			isLoading: false,
			results: null,
			startIndex: 0,
			resultsCount: 0,
		};
	},

	initialize: function() {
		_.bindAll(this, 'search');

		if ( !this.get("api") ) throw new Error("TraminoSiteSearch: A api endpoint is required");
		if ( !this.get("template_id") ) throw new Error("TraminoSiteSearch: A template_id is required");
		if ( !this.get("render_to") ) throw new Error("TraminoSiteSearch: A render_to is required");

		this.view = new SiteSearchResultView({
			model: this,
			el: document.getElementById(this.get("render_to")),
		});

	},

	/**
	 * Suchfunktion
	 */
	search: function(query) {
		if ( typeof query === "string" ) {
			query = { 'query': query };
		}
		this.set("isLoading", true);

		return ajax(this.get('api'), { params: query }).then(function(response) {
			if ( response.status && response.status === "error" ) {
				throw new Error("API call failed: " + response.message);
			}
			this.set({
				"isLoading": false,
				"startIndex": 0,
				"resultsCount": response.items.length,
				"results": response.items,
			});
			return response.results;
		}.bind(this)).catch(function(e) {
			console.log(e);
			Raven.captureException(e);
		});
	},


});

module.exports = TraminoSiteSearch;


/* API example */
/*
if ( 0 ) {
	window.SiteSearch = new TraminoSiteSearch({
		api: '/api/search/',
		template_id: 'sitesearch-template',
		render_to: 'sitesearch-result',
	});
	
	$('#search_input').on('keyup', function(e) {
		var query = $(this).val();
		if ( query.length >= 3 ) {
			SiteSearch.search(query);
		}
	});

}
*/



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/sitesearch/main.js
 **/